import {createFileRoute} from '@tanstack/react-router';
import {practitionerAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import CompanyMetrics from '@/practitioner/views/company/CompanyMetrics';

export const Route = createFileRoute('/(practitioner)/company/metrics')({
  component: CompanyMetrics,
  beforeLoad: grantUser(practitionerAdminGranted)
});
